import Form from "react-bootstrap/Form";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

interface MultiLineInfo {
  lineLimit?: number; // Max line length
  totalLimit?: number; // Max total lines
  settingName?: string;
}

export const MultiLineSetting: WidgetSettingFC<string, MultiLineInfo> = ({
  data,
  setData,
  info,
}) => {
  const items: string[] = data?.split("\n")?.filter((lineItem) => Boolean(lineItem.trim())) || [];
  const total: number = items?.length || 0;
  const setDataInternal = (newValue: string) => {
    let newItems: string[] = newValue.split("\n");
    if (info.lineLimit) {
      for (let i = 0; i < newItems.length; i++) {
        if (newItems[i].length > info.lineLimit) {
          newItems[i] = newItems[i].substring(0, info.lineLimit);
        }
      }
    }

    if (info.totalLimit && newItems.length > info.totalLimit) {
      newItems = newItems.slice(0, info.totalLimit);
    }

    setData(newItems.join("\n"));
  };

  return (
    <OuterContainer>
      <Form.Label style={{ fontWeight: "600", fontSize: "12pt", margin: "0px" }}>
        {info.settingName}
      </Form.Label>
      {info?.lineLimit && (
        <TotalText
          isAtLimit={
            Boolean(info.lineLimit) && items.some((item) => item.length === info.lineLimit)
          }
        >
          (max. {info.lineLimit} characters each)
        </TotalText>
      )}
      <Form.Control
        placeholder="One per line"
        type="text"
        as="textarea"
        rows={5}
        value={data || ""}
        onChange={(e) => setDataInternal(e.target.value)}
      />
      <TotalText isAtLimit={Boolean(info.totalLimit) && items.length === info.totalLimit}>
        Total: {total}
        {info.totalLimit && ", Max: " + info.totalLimit}
      </TotalText>
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  margin-bottom: 35px;
`;

const TotalText = styled.p<{ isAtLimit: boolean }>`
  color: ${(props) => (props.isAtLimit ? "var(--orange)" : "var(--gray)")};
`;
